import { render, staticRenderFns } from "./SmsDetail.vue?vue&type=template&id=2e60a8b8"
import script from "./SmsDetail.vue?vue&type=script&lang=js"
export * from "./SmsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports